import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UnverifiedCustomersRoutingModule } from './unverified-customers-routing.module';
import { UnverifiedCustomersComponent } from './unverified-customers.component';
import { ListGridModule } from '../../../../shared/listGrid/listGrid.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LoadingModule } from '../../../../shared/loading/loading.module';

@NgModule({
  declarations: [UnverifiedCustomersComponent],
  imports: [
    CommonModule,
    UnverifiedCustomersRoutingModule,
    ListGridModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    LoadingModule,
  ],
})
export class UnverifiedCustomersModule {}
